/**
 * ShowcaseLanding — the public NicheSocial front page.
 * Product video carousel up top, POA pricing table below.
 * (The original marketing site lives in LandingPage.js — kept in the locker.)
 */
import { useEffect, useState } from 'react';
import axios from 'axios';
import PricingTable from '@/PricingTable';
import ProductShowcase from '@/ProductShowcase';
import CustomerJourney from '@/CustomerJourney';
import FloatingNav from '@/FloatingNav';
import './ShowcaseLanding.css';

const API = process.env.REACT_APP_BACKEND_URL;
const LOGO = 'https://nichecomfiles.co.uk/proposal-examples/defaults/nichecom-logo-trimmed.png';

const NAV_ITEMS = [
  { key: 'examples', label: 'Examples', selector: '[data-testid="sl-showcase"]' },
  { key: 'pricing', label: 'Pricing', selector: '[data-testid="lp-packages"]' },
  { key: 'journey', label: 'Customer Journey', selector: '[data-testid="customer-journey"]' },
];

export default function ShowcaseLanding({ onLogin, onNavigate }) {
  const [videos, setVideos] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/example-videos/public`)
      .then((r) => setVideos(r.data))
      .catch(() => setVideos({ introductions: [], examples: [] }));
  }, []);

  return (
    <div className="sl" data-testid="showcase-landing">
      <FloatingNav items={NAV_ITEMS} />
      <header className="sl-header" data-testid="sl-header">
        <img src={LOGO} alt="NicheCom" className="sl-logo" />
        <button className="sl-login" onClick={onLogin} data-testid="sl-login-btn">Login</button>
      </header>

      <section className="sl-showcase" data-testid="sl-showcase">
        <ProductShowcase videos={videos || { introductions: [], examples: [] }} preroll="always" />
      </section>

      <section className="sl-hero sl-hero-below" data-testid="sl-hero">
        <span className="sl-eyebrow">Built for estate agents</span>
        <h1 className="sl-title">Every listing, <span>ready to share.</span></h1>
        <p className="sl-sub">
          Social ready videos and assets from every NicheCom visit — see the products in action above.
        </p>
      </section>

      <PricingTable proposal={null} onNavigate={onNavigate} />

      <CustomerJourney videos={videos || { introductions: [], examples: [] }} />

      <footer className="sl-footer" data-testid="sl-footer">
        <img src={LOGO} alt="NicheCom" className="sl-footer-logo" />
        <span>© {new Date().getFullYear()} NicheCom. All rights reserved.</span>
      </footer>
    </div>
  );
}
